<template>
  <div class="container-fluid py-4">
    <!-- Loader global lors du chargement des données -->
    <div v-if="isPageLoading" class="overlay">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Chargement...</span>
      </div>
    </div>

    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-clinique" v-if="!isPageLoading">
      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-pencil-square fs-2 text-primary"></i>
        <h2 class="fw-bold mb-0">Modifier Configuration</h2>
      </div>
      <router-link class="btn btn-primary btn-lg shadow-sm btn-clinique" :to="{ name: 'item_config' }">
        <i class="bi bi-arrow-left-circle me-2"></i> Retour
      </router-link>
    </div>

    <!-- Card formulaire -->
    <div class="card p-4 shadow-sm rounded card-clinique" v-if="!isPageLoading">
      <div class="row g-4">
        <!-- Nom -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Nom de la clinique</label>
          <input type="text" v-model="config.nom" class="form-control" :class="{ 'is-invalid': error.nom }">
          <div class="invalid-feedback">{{ error.nom }}</div>
        </div>

        <!-- Téléphone -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Téléphone</label>
          <input type="text" v-model="config.telephone" class="form-control" :class="{ 'is-invalid': error.telephone }">
          <div class="invalid-feedback">{{ error.telephone }}</div>
        </div>
         <!-- Adresse -->
        <div class="col-md-12">
          <label class="form-label fw-semibold">Ville</label>
          <input type="text" v-model="config.ville" class="form-control" :class="{ 'is-invalid': error.ville }">
          <div class="invalid-feedback">{{ error.ville }}</div>
        </div>

        <!-- Adresse -->
        <div class="col-md-12">
          <label class="form-label fw-semibold">Adresse</label>
          <input type="text" v-model="config.adresse" class="form-control" :class="{ 'is-invalid': error.adresse }">
          <div class="invalid-feedback">{{ error.adresse }}</div>
        </div>

        <!-- Description -->
        <div class="col-md-12">
          <label class="form-label fw-semibold">Description</label>
          <textarea v-model="config.description" class="form-control" rows="3"></textarea>
        </div>

        <!-- Logo -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Changer le logo</label>
          <input type="file" @change="handleFileUpload" class="form-control" accept="image/*">
          <div v-if="config.logo" class="mt-2">
            <img :src="getLogoUrl(config.logo)" class="img-thumbnail" style="max-height: 100px;">
          </div>
        </div>
      </div>

      <!-- Boutons -->
      <div class="d-flex justify-content-end gap-3 mt-4">
        <button class="btn btn-light border shadow-sm px-4 py-2" @click="cancel">Annuler</button>
        <button class="btn btn-success shadow px-4 py-2 btn-clinique" :disabled="isSaving" @click="updateConfiguration">
          <span v-if="isSaving" class="spinner-border spinner-border-sm me-2" role="status"></span>
          <span v-if="isSaving">Mise à jour...</span>
          <span v-else>Mettre à jour</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';

export default {
  data() {
    return {
      isPageLoading: true, // loader lors du chargement initial
      isSaving: false,     // loader lors de la mise à jour
      config: {
        id: null,
        nom: '',
        adresse: '',
        ville: '',
        telephone: '',
        description: '',
        logo: ''
      },
      logoFile: null,
      error: {
        nom: '',
        adresse: '',
        ville: '',
        telephone: ''
      }
    };
  },
  methods: {
    async loadConfiguration() {
      this.isPageLoading = true;
      try {
        const id = this.$route.params.id;
        const response = await api.getItem('configurations', id);
        this.config = response.data;
      } catch (err) {
        console.error("Erreur lors du chargement de la configuration", err);
        alert("Impossible de charger les données de configuration.");
      } finally {
        this.isPageLoading = false;
      }
    },
    handleFileUpload(event) {
      this.logoFile = event.target.files[0];
    },
    getLogoUrl(path) {
      return path ? `${process.env.VUE_APP_API_BASE_URL}${path}` : '';
    },
    validateForm() {
      this.error = {
        nom: this.config.nom ? '' : 'Le nom est requis',
        ville: this.config.ville ? '' : 'La ville est requise',
        adresse: this.config.adresse ? '' : 'L\'adresse est requise',
        telephone: this.config.telephone ? '' : 'Le téléphone est requis'
      };
      return !Object.values(this.error).some(err => err !== '');
    },
    async updateConfiguration() {
  if (!this.validateForm() || this.isSaving) return;

  try {
    this.isSaving = true;

    let payload;
    let isMultipart = false;

    if (this.logoFile) {
      payload = new FormData();
      payload.append('nom', this.config.nom);
      payload.append('ville', this.config.ville);
      payload.append('adresse', this.config.adresse);
      payload.append('telephone', this.config.telephone);
      payload.append('description', this.config.description);
      payload.append('logoFile', this.logoFile);
      isMultipart = true;
    } else {
      payload = {
        nom: this.config.nom,
        ville: this.config.ville,
        adresse: this.config.adresse,
        telephone: this.config.telephone,
        description: this.config.description
      };
    }

    const response = await api.updateItem('configurations', this.config.id, payload, isMultipart);

    // Mettre à jour le logo côté front avec la réponse de l'API
    this.config = response.data;

    //alert('Configuration mise à jour avec succès !');

    this.logoFile = null; // reset fichier sélectionné
    this.$router.push({ name: 'item_config' });
  } catch (error) {
    console.error('Erreur mise à jour:', error);
    alert("Une erreur s'est produite lors de la mise à jour.");
  } finally {
    this.isSaving = false;
  }
}
,
    cancel() {
      this.$router.push({ name: 'item_config' });
    }
  },
  created() {
    this.loadConfiguration();
  }
};
</script>

<style scoped>
.header-clinique {
  padding: 15px 20px;
  background-color: #e9f5ff;
  border-radius: 12px;
  margin-bottom: 20px;
}

.card-clinique {
  background: #f8fafd;
  border-radius: 12px;
  border: none;
}

.form-control {
  border-radius: 10px;
  border: 1px solid #d1e3f0;
  padding: 10px 14px;
  transition: all 0.3s ease;
}
.form-control:focus {
  box-shadow: 0 0 6px #0d6efd33;
  border-color: #0d6efd;
}

.btn-clinique {
  background: linear-gradient(90deg, #0d6efd, #6610f2);
  border: none;
  color: #fff;
  border-radius: 10px;
  transition: all 0.3s ease;
}
.btn-clinique:hover {
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
  transform: translateY(-2px);
}

/* Overlay loader */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255,255,255,0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
</style>
